import React from 'react'


const ClearButton = ({ onClick }) => (
  <button
    className="btn-clear button-clear-esuz"
    type="button"
    onClick={onClick}
  >
    <i className="fa fa-times" />
  </button>
)

export default ClearButton
